import CampaignTabHeader from '../campaign-tab-header';
import BulkMessageEditorWrapper from './bulk-message-editor-wrapper';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { namespace } from '@common-config/constants';

export default function BulkSetMessage() {
  const { t } = useTranslation(namespace);
  
  return (
    <div className={cn(
      "flex flex-col items-center",
      "w-full max-w-[750px] mx-auto px-6 pb-12"
    )}>
      <CampaignTabHeader
        title={t('messageEditor.writeMessage')}
        subTitle={t('messageEditor.addTextEmojisLinksLabelsAndFiles')}
      />

      <div className="w-full bg-white dark:bg-slate-800 rounded-xl p-6">
        <BulkMessageEditorWrapper
          isPreview={false}
        />
      </div>
    </div>
  )
}